import Input from "../Form/Input";
import SubmitButton from "../Form/SubmitButton";
import TextArea from "../Form/TextArea";
import Box from "@mui/material/Box";

import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useState, useEffect } from "react";

import {
  getFacility,
  addFacility,
  updateFacility,
} from "../../app/actions/facilities";

const FacilityDetails = (props) => {
  const initialFacilityState = {
    id: null,
    name: "",
    city: "",
    district: "",
    country: "",
    postalCode: "",
    comments: "",
  };

  const { facility_id } = useParams();

  const [loading, setLoading] = useState(false);
  const [currentFacility, setCurrentFacility] = useState(initialFacilityState);
  const { user: currentUser } = useSelector((state) => state.auth);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFocus(name);
    setCurrentFacility({ ...currentFacility, [name]: value });
  };

  const {
    register,
    handleSubmit,
    setFocus,
    formState: { errors },
  } = useForm();

  const facilityFields = [
    {
      label: "Facility Name",
      type: "text",
      name: "name",
      required: true,
    },
    {
      label: "Address",
      type: "text",
      name: "address",
      required: true,
    },
    {
      label: "City",
      type: "text",
      name: "city",
      required: true,
    },
    {
      label: "State",
      type: "text",
      name: "state",
      required: true,
    },
    {
      label: "Country",
      type: "text",
      name: "country",
      required: true,
    },
    {
      label: "Postal Code",
      type: "text",
      name: "postal_code",
      required: true,
    },
    {
      label: "Comments",
      type: "textarea",
      name: "comments",
      required: false,
    },
  ];

  const dispatch = useDispatch();
  let navigate = useNavigate();

  const onSubmit = (data) => {
    const { id: owner_id } = currentUser;
    setLoading(true);
    if (facility_id) {
      dispatch(updateFacility(facility_id, data))
        .then(() => {
          navigate("/my-facilities");
        })
        .catch(() => {
          setLoading(false);
        });
    } else {
      data = { ...data, owner_id };
      dispatch(addFacility(data))
        .then(() => {
          navigate("/my-facilities");
        })
        .catch(() => {
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    if (facility_id) {
      dispatch(getFacility(facility_id))
        .then((response) => {
          const { data: facilityData } = response;
          setCurrentFacility(facilityData);
        })
        .catch(() => {});
    }
  }, [facility_id]);

  return (
    <Box
      sx={{
        "& .MuiTextField-root": { m: 1, width: "25ch" },
      }}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        {facilityFields.map((field) =>
          field?.type == "textarea" ? (
            <TextArea
              label={field.label}
              name={field.name}
              register={register}
              options={{ required: field.required }}
              onChange={handleInputChange}
              value={currentFacility[field.name]}
            />
          ) : (
            <>
              <Input
                label={field.label}
                name={field.name}
                type={field.type}
                register={register}
                options={{ required: field.required }}
                onChange={handleInputChange}
                value={currentFacility[field.name]}
              />
              {errors[field.name] && <span>This field is required</span>}
            </>
          )
        )}

        <SubmitButton loading={loading} />
      </form>
    </Box>
  );
};

export default FacilityDetails;
